import { Box, Container, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { OverviewHeader, OverviewDateRangePicker, OverviewCharts } from "../components/Overview";

export function OverviewComponent() {
  const i18n = useI18n();

  return (
    <Container>
      <Box
        mixin={{
          paddingBlockStart: 8,
          paddingBlockEnd: 8,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
        }}
      >
        <Stack gap={12}>
          <Stack direction="column" gap={6}>
            <OverviewHeader />
            <Stack gap={1}>
              <Text variant="emphasized_2">{i18n.trans(t("flights_airline_portal_campaign_date_picker_label"))}</Text>
              <OverviewDateRangePicker />
            </Stack>
            <OverviewCharts />
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}
